import { getCoprincipalAccountSourcesByBootState, BootState } from "owa-account-source-list-store";
import { logUsage } from "owa-analytics";
import { isPstFileMailboxInfo } from "owa-client-types/lib/PstFileMailboxInfo";
import { type AccountFeatureName, isAccountFeatureEnabled, isGlobalFeatureEnabled, } from "owa-feature-flags";

export enum DiagnosticsFeature {
    Feedback = "feedback",
    InAppSupport = "inappsupport",
    GetDiagnostics = "getdiagnostics"
}

export function getAggregateFeedbackSupportFeatureFlag(diagnosticsFeature: DiagnosticsFeature): boolean {
    if (isGlobalFeatureEnabled("mon-diag-enableAggregateDiagnsoticsFeatureFlagCheck")) {
        const accounts = getCoprincipalAccountSourcesByBootState(BootState.StartupComplete).filter(account => !isPstFileMailboxInfo(account.mailboxInfo));
        let featureFlight: AccountFeatureName = "mon-diag-feedbackjs";
        switch (diagnosticsFeature) {
            case DiagnosticsFeature.Feedback:
                featureFlight = "mon-diag-feedbackjs";
                break;
            
            case DiagnosticsFeature.InAppSupport:
                featureFlight = "mon-diag-inappsupport";
                break;
            
            case DiagnosticsFeature.GetDiagnostics:
                featureFlight = "mon-diag-getDiagnostics";
                break;
        }
        
        let isDiagnosticsFeatureEnabled = true; // true by default
        
        for (const account of accounts) {
            const mailboxInfo = account.mailboxInfo;
            
            isDiagnosticsFeatureEnabled =
                isDiagnosticsFeatureEnabled && isAccountFeatureEnabled(featureFlight, mailboxInfo);
            /* eslint-disable-next-line owa-custom-rules/forbid-specific-functions-patterns-inside-loops -- (https://aka.ms/OWALintWiki)
             * Baseline, this function can't be used inside a loop, please move it outside
             *	> Function 'logUsage' matches forbidden pattern (/logUsage/) and should not be used inside loops */
            logUsage("DiagnosticsAndSupport_IsDiagnosticsFeatureFlagEnabled", mailboxInfo, {
                accountType: mailboxInfo.type,
                isFeedbackFeatureFlagEnabled: isDiagnosticsFeatureEnabled,
                entrypoint: diagnosticsFeature,
                isFeedbackFlightEnabled: isAccountFeatureEnabled(featureFlight, mailboxInfo),
            }, { sessionSampleRate: 1 });
        }
        
        return isDiagnosticsFeatureEnabled;
    }
    
    return false;
}
